<template>
	<div class="input__wrapper">
		<label>
			<span class="input-label" :id="data.labelId">{{ data.label}}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>
			<textarea
				v-on:keyup="countdown"
				v-model="inputVal"
				:id="data.inputId"
				name=""
				:placeholder="data.placeholder"
				:maxlength="data.maxlength"
				:class="data.classTextarea"
				ref="inputArea"
			></textarea>
		</label>
	</div>
</template>

<script>
export default {
	props: {
		value: [String, Number],
		placeholder: String,
		textarea: Boolean,
		type: {
			type: String,
			default: 'textarea'
		},
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		const regex = /(<([^>]+)>)/ig;
		return { inputVal: this.value ? this.value.replace(regex, '').replaceAll('&nbsp;', ' ') : '' };
	},
	watch: {
		inputVal (val) {
			this.$emit('input', val);
		}
	},
	methods: {
		setValue(value) {
			this.inputVal = value;
		},
		countdown() {
			this.$emit('countdown');
		}
	}
};
</script>

<style lang="scss" scoped>
label {
	display: block;
	margin-bottom: 15px;
}

textarea {
	display: block;
	background: none;
	box-shadow: none;
	border: 1px solid $white-lilac;
	color: $fiord;
	border-radius: 5px;
	padding: 16px;
	max-width: 100%;
	line-height: 1;
	width: 100%;
	font-size: 14px;
	text-overflow: ellipsis;
	white-space: initial;
	font-family: $font-main ;
	min-height: 200px;
	resize: none;
	border-radius: 8px;
	background-color: $white-lilac;

	&:focus {
		border: 1px solid $dodger-blue;
	}
	@include placeholder {
		color: $grey;
	}

	@include mq($sm) {
		font-size: 16px;
		padding: 13px;
	}
}

textarea::-webkit-scrollbar {
	width: 10px;
}

textarea::-webkit-scrollbar-track {
	background: $seashell;
	border-radius: 20px;
	height: 60px;
}

textarea::-webkit-scrollbar-thumb {
	background: $fiord;
	border-radius: 20px;
	transition: $dur $ease;
}

textarea::-webkit-scrollbar-thumb:hover {
	background: $fiord;
}
</style>
